// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  pointer-events: none;
}

.debug-dialog {
  position: fixed;
  background: var(--dialog-background-color);
  color: var(--text-color);
  border-radius: var(--dialog-border-radius);
  border: 2px solid var(--info-color);
  box-shadow: 0px 12px 36px rgba(0, 0, 0, 0.22);

  display: flex;
  flex-direction: column;

  /* safety on very small screens */
  min-width: 800px;
  min-height: 600px;
  max-width: 99vw;
  max-height: 99vh;

  pointer-events: all;
  overflow: hidden;
}

.debug-dialog-header {
  display: flex;
  flex-wrap: wrap;
  gap: var(--input-element-gap);
  padding: var(--input-element-gap);
  border-bottom: 1px solid var(--border-color);
  background: var(--light-blue-background-color);
  cursor: move;
  user-select: none;
  align-items: center;
  border-top-left-radius: calc(var(--dialog-border-radius) - 2px);
  border-top-right-radius: calc(var(--dialog-border-radius) - 2px);
}

.debug-dialog-header button {
  flex: 0 0 auto;
  min-width: 0;
  padding: 0 var(--font-size-l);
  border: 1px solid transparent;
  background: var(--input-background-color);
}

.debug-dialog-header button.active {
  background: var(--light-blue-background-color);
  border-color: var(--border-color);
  font-weight: bold;
}

.debug-dialog-content {
  padding: var(--dialog-padding);
  overflow: auto;
  height: 100%;
  min-height: 0;
  border-top: 1px solid var(--border-color);
}

.resize-handle {
  position: absolute;
  z-index: 2;
}

.resize-handle-top {
  top: -4px;
  left: 12px;
  right: 12px;
  height: 8px;
  cursor: n-resize;
}

.resize-handle-right {
  top: 12px;
  right: -4px;
  bottom: 12px;
  width: 8px;
  cursor: e-resize;
}

.resize-handle-bottom {
  left: 12px;
  right: 12px;
  bottom: -4px;
  height: 8px;
  cursor: s-resize;
}

.resize-handle-left {
  top: 12px;
  left: -4px;
  bottom: 12px;
  width: 8px;
  cursor: w-resize;
}

.resize-handle-top-left,
.resize-handle-top-right,
.resize-handle-bottom-left,
.resize-handle-bottom-right {
  width: 14px;
  height: 14px;
}

.resize-handle-top-left {
  top: -4px;
  left: -4px;
  cursor: nw-resize;
}

.resize-handle-top-right {
  top: -4px;
  right: -4px;
  cursor: ne-resize;
}

.resize-handle-bottom-left {
  left: -4px;
  bottom: -4px;
  cursor: sw-resize;
}

.resize-handle-bottom-right {
  right: -4px;
  bottom: -4px;
  cursor: se-resize;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/DebugOverlay.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,wBAAwB;EACxB,0CAA0C;EAC1C,mCAAmC;EACnC,6CAA6C;;EAE7C,aAAa;EACb,sBAAsB;;EAEtB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;;EAEhB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;EACjC,4CAA4C;EAC5C,8CAA8C;EAC9C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+DAA+D;EAC/D,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,8CAA8C;EAC9C,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".debug-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n.debug-dialog {\n  position: fixed;\n  background: var(--dialog-background-color);\n  color: var(--text-color);\n  border-radius: var(--dialog-border-radius);\n  border: 2px solid var(--info-color);\n  box-shadow: 0px 12px 36px rgba(0, 0, 0, 0.22);\n\n  display: flex;\n  flex-direction: column;\n\n  /* safety on very small screens */\n  min-width: 800px;\n  min-height: 600px;\n  max-width: 99vw;\n  max-height: 99vh;\n\n  pointer-events: all;\n  overflow: hidden;\n}\n\n.debug-dialog-header {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--input-element-gap);\n  padding: var(--input-element-gap);\n  border-bottom: 1px solid var(--border-color);\n  background: var(--light-blue-background-color);\n  cursor: move;\n  user-select: none;\n  align-items: center;\n  border-top-left-radius: calc(var(--dialog-border-radius) - 2px);\n  border-top-right-radius: calc(var(--dialog-border-radius) - 2px);\n}\n\n.debug-dialog-header button {\n  flex: 0 0 auto;\n  min-width: 0;\n  padding: 0 var(--font-size-l);\n  border: 1px solid transparent;\n  background: var(--input-background-color);\n}\n\n.debug-dialog-header button.active {\n  background: var(--light-blue-background-color);\n  border-color: var(--border-color);\n  font-weight: bold;\n}\n\n.debug-dialog-content {\n  padding: var(--dialog-padding);\n  overflow: auto;\n  height: 100%;\n  min-height: 0;\n  border-top: 1px solid var(--border-color);\n}\n\n.resize-handle {\n  position: absolute;\n  z-index: 2;\n}\n\n.resize-handle-top {\n  top: -4px;\n  left: 12px;\n  right: 12px;\n  height: 8px;\n  cursor: n-resize;\n}\n\n.resize-handle-right {\n  top: 12px;\n  right: -4px;\n  bottom: 12px;\n  width: 8px;\n  cursor: e-resize;\n}\n\n.resize-handle-bottom {\n  left: 12px;\n  right: 12px;\n  bottom: -4px;\n  height: 8px;\n  cursor: s-resize;\n}\n\n.resize-handle-left {\n  top: 12px;\n  left: -4px;\n  bottom: 12px;\n  width: 8px;\n  cursor: w-resize;\n}\n\n.resize-handle-top-left,\n.resize-handle-top-right,\n.resize-handle-bottom-left,\n.resize-handle-bottom-right {\n  width: 14px;\n  height: 14px;\n}\n\n.resize-handle-top-left {\n  top: -4px;\n  left: -4px;\n  cursor: nw-resize;\n}\n\n.resize-handle-top-right {\n  top: -4px;\n  right: -4px;\n  cursor: ne-resize;\n}\n\n.resize-handle-bottom-left {\n  left: -4px;\n  bottom: -4px;\n  cursor: sw-resize;\n}\n\n.resize-handle-bottom-right {\n  right: -4px;\n  bottom: -4px;\n  cursor: se-resize;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
